module.exports = __webpack_public_path__ + "media/CGM1.f5e74241.mp4";